module.exports = __webpack_public_path__ + "media/TAMA_Sommerquiz_26_16x9_komprimiert.6344d716.mp4";